import { Container } from 'components/container'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const StyledFooter = styled.footer`
  margin: 6rem 0 3rem;
  font-size: 1.8rem;

  ${mq.medium} {
    margin-top: 8rem;
  }

  ${mq.large} {
    margin-top: 12rem;
  }

  ${Container} {
    display: grid;
    gap: 3rem;
    grid-template-columns: auto;
    grid-template-areas: 'authors' 'about' 'social' 'credit';
    justify-content: space-between;

    ${mq.medium} {
      grid-template-columns: auto auto;
      grid-template-areas: 'authors about' 'social credit';
    }

    ${mq.large} {
      grid-template-columns: 39rem 1fr;
      gap: 0 9rem;
    }
  }
  ${mq.smallOnly} {
    display: none;
  }
`

export const Authors = styled.div`
  grid-area: authors;
`

export const About = styled.div`
  grid-area: about;
`

export const Social = styled.div`
  grid-area: social;
`

export const SocialLinks = styled.ul`
  margin: 1.5rem 0 0;
  padding: 0;
  list-style: none;

  li {
    display: inline;
    padding: 0;
    margin: 0;
  }

  a {
    display: inline-block;
    font-size: 4rem;
    width: 1em;
    height: 1em;
    margin: 0 0.2em;
    color: white;
    transition: all 0.3s;
    overflow: hidden;
    background: linear-gradient(
        to top,
        ${theme.colors.accent.secondary} 50%,
        ${theme.colors.accent.primary} 50%
      )
      50% 0/100% 200%;

    svg {
      display: block;
    }

    &:hover,
    &:focus {
      background-position: 50% 100%;
    }
  }

  ${mq.smallOnly} {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 0.8rem;
    max-width: 30rem;

    a {
      display: block;
      width: 100%;
      height: auto;
    }

    svg {
      width: 100%;
      display: block;
    }
  }
`

export const Heading = styled.h4`
  font-weight: normal;
  font-size: 2.1rem;
  text-transform: uppercase;
  margin: 0;

  &:not(:first-child) {
    margin-top: 6rem;
  }
`

export const Copyright = styled.p`
  font-size: 1.6rem;
  color: rgba(255, 255, 255, 0.5);
  grid-area: credit;

  ${mq.medium} {
    margin-top: 6.5rem;
  }
`
